import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import version from '../../../../../../../version.json';

import { ConfirmationModalService, ModalTemplateComponent } from '@nx-ahs/shared/components';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@Component({
	selector: 'app-about-ht',
	templateUrl: './about-ht.component.html',
	styleUrls: ['./about-ht.component.scss'],
	standalone: true,
	imports: [ModalTemplateComponent, FlexLayoutModule]
})
export class AboutHtComponent implements OnInit {
	public version: string;

	constructor(
		private dialogRef: MatDialogRef<AboutHtComponent>,
		private confirmationModalService: ConfirmationModalService
	) {}

	ngOnInit() {
		this.version = version.version;

		this.dialogRef.keydownEvents().subscribe((event) => {
			if (event.key === 'Escape') {
				this.close();
			}
		});
		this.dialogRef.backdropClick().subscribe(() => {
			this.close();
		});
	}

	public close(): void {
		this.confirmationModalService
			.showConfirmationDialog('Confirm Cancel', 'Click OK to continue')
			.beforeClosed()
			.toPromise()
			.then((result) => {
				if (result) {
					this.dialogRef.close(undefined);
				}
			});
	}
}
